<template>
  <div class="generalContainer">
    <div class="rowProvisionService">
      <div class="ContentTable">
        <div class="headerTable">
          <div class="celTable" style="width: 10%">Data Emissão</div>
          <div class="celTable" style="width: 10%">Data Execução</div>
          <div class="celTable" style="width: 30%">Cliente</div>
          <div class="celTable" style="width: 20%">Funcionário</div>
          <div class="celTable" style="width: 10%">Status</div>
          <div class="celTable" style="width: 10%">Total</div>
          <div class="celTableActions">Ações</div>
        </div>
        <div
          v-for="nfse in dataFilterNfse"
          :key="nfse.id"
          :class="`rowSupplier`"
          @click.stop="findNfseById(nfse.id)"
        >
          <div class="celTable" style="width: 10%">
            {{ formatDate(nfse.data_nfse) }}
          </div>
          <div class="celTable" style="width: 10%">
            {{ formatDate(nfse.data_execucao) }}
          </div>
          <div class="celTable" style="width: 30%">
            {{ nfse.nome || "______" }}
          </div>
          <div class="celTable" style="width: 20%">
            {{ nfse.nomeFuncionario }}
          </div>
          <div class="celTable" style="width: 10%">
            <InputSelect
              :items="nfseSituationsNfse"
              valueField="value"
              textField="text"
              :enableIconCreate="false"
              :dataSelect.sync="nfse.status"
              ref="dataFilterNfse"
              @changed="handleUpdateOrCancelNfse(nfse)"
              textCenter
            />
          </div>
          <div class="celTable" style="width: 10%">
            {{
              nfse.valorTotal
                ? nfse.valorTotal.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : "R$ 0,00"
            }}
          </div>
          <div class="celTableActions">
            <div class="btnActions">
              <b-dropdown
                id="dropdown-1"
                class="btnActions"
                size="sm"
                variant="none"
              >
                <template #button-content>
                  <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                </template>
                <b-dropdown-item @click.stop="printReportOrder(nfse.id)">
                  Imprimir
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="nfse.response"
                  @click.stop="printNfse(nfse.id)"
                >
                  Abrir PDF
                </b-dropdown-item>
                <b-dropdown-item @click.stop="forwardToFinance(nfse)">
                  Gerar Parcelas
                </b-dropdown-item>
                <b-dropdown-item
                  @click.stop="getIdToRemoveOrderService(nfse.id)"
                  v-b-modal.modalConfirmDeletion
                  v-if="nfse.status !== 'Faturado'"
                >
                  Excluir
                </b-dropdown-item>
                <b-dropdown-item
                  @click.stop="detailsNfse(nfse.id)"
                  v-b-modal.modal-details
                >
                  Ver Detalhes
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modalConfirmDeletion"
        hide-footer
        hide-header
        centered
        title="Excluir"
      >
        <div>
          <h6 class="titleModal">Deseja excluir essa movimentação ?</h6>
          <div class="btnModal">
            <button class="btnContent" @click="deleteOrder">Deletar</button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modalConfirmDeletion')"
            >
              Não, Obrigado!
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modal-details"
        hide-footer
        centered
        size="xl"
        body-class="p-0"
      >
        <template #modal-header="{ close }">
          <div class="d-flex justify-content-between align-items-center w-100">
            <h5 class="m-0">
              <b-icon-file-text class="mr-2"></b-icon-file-text>Detalhes da Nota
              de Serviço
            </h5>
            <div style="display: flex; align-items: center; gap: 5px">
              <div>
                <b-badge
                  :variant="
                    detailsData.status === 'Pago' ? 'success' : 'warning'
                  "
                  pill
                >
                  {{ detailsData.status }}
                </b-badge>
              </div>
              <b-button size="sm" variant="outline-light" @click="close()">
                <b-icon-x></b-icon-x>
              </b-button>
            </div>
          </div>
        </template>

        <div style="padding: 1rem 2rem">
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="mb-1 col-md-4"
              style="font-size: 13px; flex-direction: column; display: flex"
            >
              <strong>Nome:</strong>
              <span>
                {{ detailsData.nomeCliente }}
              </span>
            </div>
            <div
              class="mb-1 col-md-4"
              style="font-size: 13px; flex-direction: column; display: flex"
            >
              <strong>CPF/CNPJ:</strong>
              <span>
                {{ detailsData.cpfCnpj }}
              </span>
            </div>
            <div
              class="mb-1 col-md-4 text-md-right"
              style="font-size: 13px; flex-direction: column; display: flex"
            >
              <strong>Funcionário:</strong>
              <span>
                {{ detailsData.nomeFuncionario || "Não informado" }}
              </span>
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <div class="col-md-4" style="font-size: 13px">
              <label style="margin: 0" class="text-muted small d-block"
                >Nº Referência</label
              >
              <strong>{{ detailsData.referencia || "--" }}</strong>
            </div>
            <div class="col-md-4" style="font-size: 13px">
              <label style="margin: 0" class="text-muted small d-block"
                >Data de Emissão</label
              >
              <strong>{{ detailsData.data_nfse }}</strong>
            </div>
            <div class="col-md-4 text-md-right" style="font-size: 15px">
              <label style="margin: 0" class="text-muted small d-block"
                >Total da Nota</label
              >
              <strong class="text-primary">R$ {{ calcularTotalNota() }}</strong>
            </div>
          </div>

          <hr />

          <div>
            <span class="d-flex align-items-center" style="font-size: 14px">
              <b-icon-box-seam class="mr-2"></b-icon-box-seam> Serviços
            </span>
            <div class="table-responsive" style="min-height: 30vh">
              <table class="table table-sm table-hover border">
                <thead class="bg-light">
                  <tr>
                    <th style="padding-left: 10px !important">N° NFS-e</th>
                    <th style="width: 35%">Nome</th>
                    <th class="text-center">Qtd</th>
                    <th class="text-right">Unitário</th>
                    <th class="text-right">Desconto</th>
                    <th class="text-right">Subtotal</th>
                    <th class="text-center">Status Fiscal</th>
                    <th class="text-center" style="width: 8%">Imprimir</th>
                    <th class="text-center" style="width: 8%">Ações</th>
                  </tr>
                </thead>
                <tbody style="font-size: 14px; text-transform: uppercase">
                  <tr v-for="item in detailsData.services" :key="item.id">
                    <td
                      style="padding-left: 10px !important"
                      v-if="item.response"
                    >
                      {{ item.response.numero }}
                    </td>
                    <td v-else style="padding-left: 10px !important">--</td>
                    <td>{{ item.nome }}</td>
                    <td class="text-center">{{ item.quantidade }}</td>
                    <td class="text-right">{{ item.valor }}</td>
                    <td class="text-right text-danger">
                      {{ item.desconto || "0,00" }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{ item.valorTotal }}
                    </td>
                    <td class="text-center">
                      <b-badge
                        :variant="getItemStatusVariant(item)"
                        v-b-tooltip.hover
                        :title="getItemError(item)"
                      >
                        {{ getItemStatusText(item) }}
                      </b-badge>
                    </td>
                    <td class="text-center" style="width: 8%">
                      <b-button
                        v-if="isItemApproved(item)"
                        variant="link"
                        size="sm"
                        v-b-tooltip.hover
                        title="Imprimir NFS-e"
                        @click="printItemPdf(item)"
                      >
                        <b-icon-printer-fill
                          text-variant="primary"
                        ></b-icon-printer-fill>
                      </b-button>

                      <button
                        class="btn-retry"
                        v-if="canRetryItem(item)"
                        @click="retryEmitItem(item)"
                      >
                        <b-icon-play /> Emitir
                      </button>
                    </td>
                    <td
                      style="
                        display: flex;
                        justify-content: center;
                        width: 100%;
                      "
                      v-if="isItemApproved(item)"
                    >
                      <div class="btnActions">
                        <b-dropdown
                          id="dropdown-1"
                          class="btnActions"
                          size="sm"
                          variant="none"
                        >
                          <template #button-content>
                            <b-icon-gear-fill
                              class="contentActions"
                            ></b-icon-gear-fill>
                          </template>
                          <b-dropdown-item
                            @click="openModalCancelNfse(item.id)"
                          >
                            Cancelar NFS-e
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="downloadXml(item.id, item.response)"
                          >
                            Download XML
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </td>
                    <td class="text-center" v-else style="width: 8%">--</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="detailsData.bills && detailsData.bills.length > 0">
            <span class="d-flex align-items-center" style="font-size: 14px">
              <b-icon-credit-card-fill class="mr-2"></b-icon-credit-card-fill>
              Duplicatas
            </span>
            <div class="table-responsive">
              <table class="table table-sm text-center border">
                <thead class="bg-light">
                  <tr>
                    <th>Vencimento</th>
                    <th>Pagamento</th>
                    <th style="width: 16%">Status</th>
                    <th style="width: 16%">Vl Total</th>
                    <th style="width: 16%">Vl Pago</th>
                    <th style="width: 10%">Excluir</th>
                  </tr>
                </thead>
                <tbody class="small">
                  <tr v-for="bill in detailsData.bills" :key="bill.id">
                    <td>
                      {{
                        bill.data.split(" ")[0].split("-").reverse().join("/")
                      }}
                    </td>
                    <td>
                      {{ bill.dataPagamento ? bill.dataPagamento : "--" }}
                    </td>
                    <td>
                      <span :class="bill.dataPagamento ? 'text-success' : ''">
                        <b-icon
                          :icon="
                            bill.dataPagamento
                              ? 'check-circle-fill'
                              : 'clock-fill'
                          "
                        ></b-icon>
                        {{ bill.dataPagamento ? "Pago" : "Em Aberto" }}
                      </span>
                    </td>
                    <td class="font-weight-bold text-dark">
                      {{
                        bill.valorTotal.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </td>
                    <td>
                      {{
                        bill.valorPago.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </td>
                    <td>
                      <b-button
                        variant="link"
                        size="sm"
                        class="text-danger p-0"
                        @click="deleteBill(dataBill, dataBill.id)"
                      >
                        <b-icon icon="trash"></b-icon>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalCancelNfse"
        hide-footer
        hide-header
        centered
        title="Excluir"
        @hidden="clearId"
      >
        <div>
          <h6 class="titleModal">Cancelar NFS-e</h6>
          <div class="p-3">
            <InputSelect
              label="Motivo do cancelamento"
              :items="reasonsForCancellationNFSe"
              valueField="value"
              textField="text"
              :enableIconCreate="false"
              :dataSelect.sync="motivo"
            />
          </div>
          <div class="btnModalCancelNfse">
            <button class="btnContent" @click="cancelNfse">
              Confirmar cancelamento
              <b-spinner v-if="spinFromCancelNfse" class="spin" />
            </button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modalCancelNfse')"
            >
              Não, Obrigado!
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

import ServiceNfse from "../../services/serviceNfse";
import ServiceItemNfse from "../../services/serviceNfseItem";
import ServiceBill from "../../services/serviceBill";

import { HandleErrors } from "../../utils/handleErrors";
import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import { NfseModel } from "../../utils/enums/NfseModel";
import { TypeSituationNfse } from "../../utils/enums/TypeSituationNfse";

import { nfseSituationsNfse } from "../../common";
import printReport from "../../reports/sale";

export default {
  props: {
    page: {
      type: [Number, String],
      default: 1,
    },
    typeDocument: {
      type: String,
      default: NfseModel.NFSE,
    },
    searchPerStatus: {
      type: String,
      default: null,
    },
    dataFilterNfse: {},
  },
  components: {
    InputSelect,
  },
  data() {
    return {
      dataSearchNfse: [],
      spin: false,
      filter: {
        text: "",
        type: "",
        startDate: "",
        endDate: "",
      },
      filterOptions: [
        { value: "", text: "Selecione uma opção" },
        { value: "nomeCliente", text: "Cliente" },
        { value: "status", text: "Status" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "referencia", text: "Referencia" },
      ],
      situationOptions: [
        { value: "", text: "Selecione um status" },
        { text: "Pendente", value: "Pendente" },
        { text: "Em andamento", value: "Em andamento" },
        { text: "Finalizado", value: "Finalizado" },
        { text: "Faturado", value: "Faturado" },
        { text: "Cancelado", value: "Cancelado" },
      ],
      idToRemoveOrderService: "",
      dataBills: [],
      isCpfCnpj: false,
      nfseSituationsNfse: nfseSituationsNfse,
      nfseModel: NfseModel,
      idFromCancelNfse: "",
      idItemToCancel: "",
      motivo: "",
      reasonsForCancellationNFSe: [
        { text: "Erro na emissão", value: 1 },
        { text: "Serviço não prestado", value: 2 },
        { text: "Duplicidade da nota", value: 4 },
      ],
      spinFromCancelNfse: false,
      detailsData: {},
    };
  },
  methods: {
    ...mapMutations([
      "SET_DATA_SEARCH_FROM_PROVISION_SERVICE",
      "SET_DATA_SEARCH_FROM_BILL",
    ]),
    async searchAll() {
      try {
        this.dataSearchNfse = await ServiceNfse.search(
          "",
          "",
          1,
          this.filter.startDate,
          this.filter.endDate,
          this.typeDocument
        );

        this.$emit("tableLength", this.dataSearchNfse.length);
        this.handleStatusRef();
      } catch (error) {
        this.$toast.open({
          message: error?.reponse?.data?.message || "Ocorreu um erro ao listar",
          type: "info",
        });
      }
    },

    async updateStatus(id, status) {
      try {
        await ServiceNfse.updateStatus(id, { status });
        this.$toast.open({
          message: `Status alterado para (${status})`,
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && Object.keys(typeError).length) {
          this.searchAll();
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message: "Ocorreu um erro ao atualizar o status",
          type: "info",
        });
      }
    },

    async cancelNfse() {
      if (!this.motivo) {
        return this.$toast.info("Por favor, selecione um motivo.");
      }
      try {
        this.spinFromCancelNfse = true;
        await ServiceNfse.cancelNfse(
          this.idFromCancelNfse,
          this.motivo,
          this.idItemToCancel
        );

        this.$bvModal.hide("modalCancelNfse");
        this.$toast.success("Serviço cancelado com sucesso");
        await this.detailsNfse(this.idFromCancelNfse);
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Erro ao cancelar");
      } finally {
        this.spinFromCancelNfse = false;
      }
    },

    async handleUpdateOrCancelNfse(nfse) {
      if (
        this.typeDocument === NfseModel.NFSE &&
        nfse.status === TypeSituationNfse.cancelado
      ) {
        this.$toast.info(
          "O cancelamento deve ser realizado exclusivamente através do menu Ações, nos detalhes da NFS-e."
        );
      } else {
        await this.updateStatus(nfse.id, nfse.status);
      }
    },

    async findNfseById(id) {
      const data = await ServiceNfse.findById(id);
      this.handleEdit(data);
    },

    async detailsNfse(id) {
      const data = await ServiceNfse.findByIdCompleted(id);
      this.detailsData = data;
      const dataSalesFormated = this.detailsData.data_nfse
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");
      this.detailsData.data_nfse = dataSalesFormated;
    },
    calcularTotalNota() {
      return this.detailsData.services
        ? this.detailsData.services
            .reduce((acc, item) => acc + parseFloat(item.valorTotal), 0)
            .toFixed(2)
        : "0,00";
    },
    getItemStatusVariant(item) {
      if (!item.response) return "secondary";
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      if (res.status === "aprovado") return "success";
      if (res.error || res.status === "erro") return "danger";
      return "warning";
    },
    getItemStatusText(item) {
      if (!item.response) return "Pendente";
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      return res.status === "aprovado"
        ? "Aprovado"
        : res.error
        ? "Erro"
        : "Falha";
    },
    getItemError(item) {
      if (!item.response) return "";
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      return res.error || res.motivo || "";
    },

    isItemApproved(item) {
      if (!item.response) return false;
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      return res.status === "aprovado" && res.pdf_nfse;
    },
    canRetryItem(item) {
      if (!item.response) return true;
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      return res.status !== "aprovado";
    },

    printItemPdf(item) {
      const res =
        typeof item.response === "string"
          ? JSON.parse(item.response)
          : item.response;
      if (res.pdf_nfse) {
        window.open(res.pdf_nfse, "_blank");
      }
    },
    async downloadXml(idItem, response) {
      if ((!response || !response.xml, !idItem)) {
        return;
      }

      try {
        await ServiceItemNfse.downloadSingleXml(
          idItem,
          response?.numero || null
        );

        this.$toast.open({
          type: "success",
          message: "Download realizado com sucesso!",
        });
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: "Ocorreu um problema ao realizar o download do xml!",
        });
      }
    },
    async retryEmitItem(item) {
      try {
        this.$toast.info(`Re-emitindo serviço: ${item.nome}...`);
        await ServiceNfse.sendItem(item.id);

        this.$toast.success("Processamento concluído!");
        this.detailsNfse(this.detailsData.id);
      } catch (error) {
        this.$toast.error("Falha ao tentar emitir o item.");
      }
    },
    async deleteOrder() {
      try {
        await ServiceNfse.deleteAll(this.idToRemoveOrderService);
        this.idToRemoveOrderService = "";

        this.$bvModal.hide("modalConfirmDeletion");

        return this.$toast.open({
          message: "Movimentação Excluida!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao deletar!",
          type: "info",
        });
      }
    },

    async deleteBill(bill, id) {
      await ServiceBill.deleteAllRelationshipsFromDuplicate(id);

      this.findBills(bill.idNfse);
    },

    async findBills(id) {
      this.dataBills = await ServiceBill.getAllBillsByParamsId(
        id,
        BillColumnsToSearchById.idNfse
      );
    },

    clearId() {
      this.idFromCancelNfse = "";
      this.idItemToCancel = "";
      this.motivo = "";
    },

    openModalCancelNfse(itemId) {
      this.idItemToCancel = itemId;
      this.idFromCancelNfse = this.detailsData.id;
      this.motivo = "";
      this.$bvModal.show("modalCancelNfse");
    },

    forwardToFinance(nfse) {
      this.SET_DATA_SEARCH_FROM_BILL({
        idCliente: nfse.idCliente,
        valorTotal: nfse.valorTotal,
      });

      return this.$router.push({
        path: `/financeiro`,
      });
    },

    handleStatusRef() {
      this.$nextTick(() => {
        this.dataFilterNfse.forEach((order, idx) => {
          this.$refs.dataFilterNfse[idx].valueItems = order.status;
        });
      });
    },

    getIdToRemoveOrderService(id) {
      this.idToRemoveOrderService = id;
    },

    async printNfse(id) {
      try {
        const pdfUrl = await ServiceNfse.printNfse(id);

        window.open(pdfUrl, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    handleEdit(dataNfse) {
      this.SET_DATA_SEARCH_FROM_PROVISION_SERVICE(dataNfse);
      this.$emit("openToEdit", "nfse");
    },

    clearFilterText() {
      if (this.filter.type === "cpfCnpj") {
        this.isCpfCnpj = true;
      } else {
        this.isCpfCnpj = false;
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    printReportOrder(id) {
      printReport("reportOrder", id);
    },
  },
  created() {
    // this.searchNfses(1);
    this.handleStatusRef();
    this.SET_DATA_SEARCH_FROM_PROVISION_SERVICE({});
  },
  watch: {
    // page() {
    //   this.searchNfses(this.page);
    // },
    dataFilterNfse() {
      this.handleStatusRef();
    },
    searchPerStatus() {
      this.filter.text = this.searchPerStatus;
      this.filter.type = "status";
      // this.searchNfses();
    },
  },
};
</script>

<style scoped>
.generalContainer {
  display: flex;
  flex-direction: column;
  padding: 5px;
  width: 100%;
  max-width: 100%;
  background: white;
  border-radius: 5px;
}

.rowProvisionService {
  height: 100%;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 10%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  display: flex;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: normal;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.btnModalCancelNfse {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.spin {
  position: absolute;
  right: 5px;
  height: 18px;
  width: 18px;
  color: white;
}

.btnContent {
  position: relative;
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}
.btn-retry {
  background: #006256;
  color: white;
  border: none;
  padding: 1px 10px;
  font-size: 12px;
  border-radius: 4px;
}

.table th,
.table td {
  padding: 5px !important;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}
.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}
.closeModalDetails {
  width: 22px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -2px;
  top: -1px;
  color: red;
  border-radius: 2px;
  cursor: pointer;
  transition: ease-in all 0.2s;
  font-size: 18px;
}
.input-group-supplier {
  width: 45%;
  position: relative;
}
.user-label {
  position: absolute;
  left: 15px;
  font-size: 11px;
  z-index: 30;
  bottom: 21px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.ContentTableBill {
  display: flex;
  flex-direction: column;
  overflow: auto;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  padding: 0 0 10px 0;
  background: #fbfbfb;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
}

.noContentTable {
  background: #edebeb;
  padding: 10px;
  height: 100%;
  text-align: center;
  letter-spacing: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #3e66ae;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

/* MODAL BILLS */
.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.titleModalBill {
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #e6e7e8;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.closeModalBill {
  cursor: pointer;
}

.closeModalBill:hover {
  color: red;
}

.contentTableBill {
  display: flex;
  flex-direction: column;
  overflow: auto;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  padding: 0 0 10px 0;
  background: #fbfbfb;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
}

.noContentTable {
  background: #edebeb;
  padding: 10px;
  height: 100%;
  text-align: center;
  letter-spacing: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentStatus {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 60px;
}

.contentStatus span {
  cursor: context-menu;
}

.statusPayment {
  background: #eff0f0;
  color: green;
}

.statusPaymentOpen {
  background: #eff0f0;
  color: rgb(132, 132, 132);
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  color: whitesmoke;
}

.closeModalBill {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: transparent;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalBill:hover {
  background: whitesmoke;
  color: red;
}

.closeModalBill:focus {
  background: red;
  border: none;
  box-shadow: none;
}
/* BTN REMOVE BILL */

.buttonRemoveBill {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #3a4750;
  color: whitesmoke;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);
  cursor: pointer;
  transition-duration: 0.3s;
  overflow: hidden;
  position: relative;
}

.buttonRemoveBill:hover {
  width: 70px;
  border-radius: 50px;
  transition-duration: 0.3s;
  background-color: rgb(255, 69, 69);
  align-items: center;
}

.buttonRemoveBill::before {
  position: absolute;
  top: -33px;
  content: "Deletar";
  color: white;
  transition-duration: 0.3s;
  font-size: 2px;
}

.buttonRemoveBill:hover::before {
  font-size: 10px;
  opacity: 1;
  transform: translateY(30px);
  transition-duration: 0.3s;
}

.searchContainer {
  height: auto;
  width: 100%;
}

@media screen and (max-width: 1200px) and (min-width: 768px) {
  .searchContainer {
    padding-top: 0;
  }
}

@media screen and (max-width: 700px) {
  .generalContainer {
    padding: 20px 0 !important;
  }
}

@media screen and (max-width: 700px) {
  .searchContainer {
    padding: 0 0 1rem 0;
  }
}
</style>